import React from 'react';
import PropTypes from 'prop-types';

import { forEach } from 'lodash';

const Filters = (props) => {
  const onClick = (type) => (e) => {
    e.preventDefault();
    const links = document.querySelectorAll('.filter-wrapper > li > a');
    forEach(links, (element) => {
      element.classList.remove('selected');
    });
    e.target.classList.add('selected');
    props.handleFilter(type);
  };

  return (
    <ul className="filter-wrapper">
      <li>
        <div className="circle empty-circle" />
        <a href="#" onClick={onClick('filterby-not_started')}>
          Not started
        </a>
      </li>
      <li>
        <div className="circle half-circle" />
        <a href="#" className="" onClick={onClick('filterby-in_progress')}>
          In progress
        </a>
      </li>
      <li>
        <div className="circle full-circle" />
        <a href="#" onClick={onClick('filterby-completed')}>
          Submitted
        </a>
      </li>
      <li>
        <a href="#" className="selected" onClick={onClick('')}>
          Show All
        </a>
      </li>
    </ul>
  );
};

Filters.defaultProps = {
  handleFilter: (x) => x,
};

Filters.propTypes = {
  handleFilter: PropTypes.func,
};

export default Filters;
